import React, { useEffect, useReducer } from 'react';
import { CSSTransition } from 'react-transition-group';

import PageLayout from 'layouts/PageLayout';
import BasicButton from 'components/BasicButton';
import HorizontalLoader from 'components/HorizontalLoader';
import RecruiterProcessSurveyForm from 'scenes/Form/components/RecruiterProcessSurveyForm';

import useApi from 'hooks/useApi';
import { ROUTE } from 'constants/route';
import { ENDPOINT } from 'constants/endpoints';
import { ANIMATION_TIMEOUT_APPEAR } from 'constants/animation.js';

import image from 'assets/images/404.svg';
import './styles.css';

const initialState = {
  init: false,
  isSurveyCompleted: false,
  isTokenAccepted: null,
  initialValues: {
    Score: null,
    token: null,
  },
};

const ACTION = {
  INIT_PAGE_SUCCESS: 'INIT_PAGE_SUCCESS',
  INIT_PAGE_FAIL: 'INIT_PAGE_FAIL',
  SUBMIT_SURVEY: 'SUBMIT_SURVEY',
};

const reducer = (state, action) => {
  const { type, data } = action;

  switch (type) {
    case ACTION.INIT_PAGE_FAIL:
      return { ...state, init: true, isTokenAccepted: false };

    case ACTION.INIT_PAGE_SUCCESS:
      return {
        ...state,
        init: true,
        isTokenAccepted: true,
        initialValues: { ...data },
      };

    case ACTION.SUBMIT_SURVEY:
      return { ...state, isSurveyCompleted: true };

    default:
      throw new Error();
  }
};

const RecruiterProcessSurvey = props => {
  const { user, history, location } = props;

  useEffect(() => {
    const q = new URLSearchParams(location.search);
    const token = q.get('token');

    if (!token) {
      history.push(ROUTE.ERROR_404);
      return;
    }

    api.get(
      ENDPOINT.OTHER.RECRUITER_PROCESS_SURVEY_CHECK_TOKEN,
      { token },
      {
        handleError: () => dispatch({ type: ACTION.INIT_PAGE_FAIL }),
        handleSuccess: () =>
          dispatch({
            type: ACTION.INIT_PAGE_SUCCESS,
            data: {
              Score: q.get('score'),
              token,
            },
          }),
      }
    );
  }, []);

  const api = useApi();
  const [state, dispatch] = useReducer(reducer, initialState);

  const goHome = () => {
    if (user.isLoggedIn) {
      history.push(ROUTE.HOME);
    } else {
      window.location = '/';
    }
  };

  const handleAfterSave = () => {
    dispatch({ type: ACTION.SUBMIT_SURVEY });
  };

  return (
    <PageLayout
      pageClass="survey"
      pageTitle="Survey"
      mainContent={
        state.init ? (
          <CSSTransition
            in={true}
            appear={true}
            timeout={ANIMATION_TIMEOUT_APPEAR}
            classNames="fade"
          >
            {state.isTokenAccepted ? (
              <div className="survey__row">
                {state.isSurveyCompleted ? (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <p className="survey__text">
                      Thank you for taking the time to complete this survey.
                    </p>

                    <div className="survey__button" style={{ margin: '0' }}>
                      <BasicButton
                        controlFunc={goHome}
                        btnWidth={180}
                        btnHeight={35}
                        btnFontSize="0.8571rem"
                        btnFontWeight={600}
                        btnText="Go to homepage"
                        btnArrow={false}
                      />
                    </div>
                  </div>
                ) : (
                  <RecruiterProcessSurveyForm
                    initialValues={state.initialValues}
                    onAfterSave={handleAfterSave}
                  />
                )}
              </div>
            ) : (
              <div className="survey__row">
                <div className="survey__image">
                  <img
                    src={image}
                    alt="empty box"
                    height="auto"
                    width="260px"
                  />
                </div>

                <div className="survey__cta">
                  <h1 className="survey__title">INVALID LINK</h1>
                  <p className="survey__text">
                    This link has already been used or expired.
                  </p>

                  <div className="survey__button">
                    <BasicButton
                      controlFunc={goHome}
                      btnWidth={180}
                      btnHeight={35}
                      btnFontSize="0.8571rem"
                      btnFontWeight={600}
                      btnText="Go to homepage"
                      btnArrow={false}
                    />
                  </div>
                </div>
              </div>
            )}
          </CSSTransition>
        ) : (
          <div className="form__inner">
            <div className="horizontal-loader__container">
              <HorizontalLoader />
            </div>
          </div>
        )
      }
    />
  );
};

export default RecruiterProcessSurvey;
